export enum AddressParentRelationshipNames {
    OBJECT_LEADS = 'objectLeads',
    DELIVERY_OFFERS = 'deliveryOffers',
    BILLING_OFFERS = 'billingOffers',
}
